import React, {useCallback, useEffect, useMemo, useState} from "react";
import Box from "@mui/material/Box";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import MenuItem from "@mui/material/MenuItem";
import JobWorkersService from "../../../../../../API/organization/JobWorkersService";
import TextFieldValidation from "../../../customer-detales/TextFieldValidation";
import Typography from "@mui/material/Typography";
import DateInput from "../../../../filter/DateInput";
import ButtonCreate from "../../../../button/ButtonCreate";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import {Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack} from "@mui/material";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import ButtonSelectAction from "../../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../modal/ModalSelectAction";
import selectionTableUtil, {normalizeSelection} from "../../../../../../utils/common/SelectionTableUtil";

const SalaryTable = ({
                         tableOptions,
                         tableOptionsHandle,
                         handleModalAlert,
                         workers,
                         startInitValue,
                         date,
                         setDate
                     }) => {
    const [data, setData] = useState([]);
    const [formState, setFormState] = useState({workerId: "all"});
    const [modal, setModal] = useState(false)
    const [rowSelection, setRowSelection] = useState([]);
    const [open, setOpen] = useState(false)

    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const getData = (workerId, startShipped, finishShipped, startCompletion, finishCompletion, startPaid, finishPaid) => {
        JobWorkersService.getAllWithFilter(tableOptions.pageIndex, tableOptions.pageSize, workerId, startCompletion, startShipped, startPaid, finishCompletion, finishShipped, finishPaid).then(function (response) {
            const data = response.data.content;
            tableOptionsHandle((prev) => ({...prev, totalElements: response.data.total}))
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }
    useEffect(() => {
        applyFilter()
    }, [tableOptions.pageIndex, tableOptions.pageSize]);

    const calcSum = (type) => {
        return data.reduce((acc, mEU) => {
            if (mEU[type] !== null && mEU[type] !== 0) {
                return acc + mEU[type];
            } else {
                return acc;
            }
        }, 0)?.toLocaleString?.('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 3,
        })
    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'worker',
                header: 'Работник',
                accessorKey: 'worker',
                minSize: 500,
                Cell: ({cell}) => {
                    const worker = cell.getValue();

                    if (!worker) {
                        return "Нет данных"; // или любой другой placeholder, например: ""
                    }

                    return `${worker.lastName || ''} ${worker.firstName?.substring(0, 1) || ''}.${worker.middleName?.substring(0, 1) || ''}.`;
                }
            },
            {
                id: 'date',
                header: 'Дата',
                accessorKey: 'date',
                minSize: 100,
            },
            {
                id: 'completion',
                header: 'Выполнено',
                accessorKey: 'completion',
                minSize: 100,
            },
            {
                id: 'paid',
                header: 'Оплачено',
                accessorKey: 'paid',
                minSize: 100,
            },
            {
                id: 'shipped',
                header: 'Отгружено',
                accessorKey: 'shipped',
                minSize: 100,
            },
            {
                id: 'fullTime',
                header: 'Полное время',
                accessorKey: 'fullTime',
                minSize: 100,
                Cell: ({row}) => row.original.fullTime?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {calcSum("fullTime")}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'personalTime',
                header: 'Персональное время',
                accessorKey: 'personalTime',
                minSize: 100,
                Cell: ({row}) => row.original.personalTime?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {calcSum("personalTime")}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'noted',
                header: 'Примечание',
                accessorKey: 'noted',
                minSize: 500,
            },

        ];

        return baseColumns;

    }, [data, setData]);

    const handleDeleteRow = (row) => {
        JobWorkersService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data?.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const applyFilter = (newDate = date, workerId = formState.workerId) => {
        const values = Object.values(newDate).map(el => DateTimeUtil.convertToJavaDate(el))
        getData(formState.workerId === "all" ? null : workerId, ...values)
    }

    const cancelFilter = (clear) => {
        const newDate = {
            startShipped: clear ? null : startInitValue,
            finishShipped: null,
            startCompletion: null,
            finishCompletion: null,
            startPaid: null,
            finishPaid: null
        }
        setFormState({workerId: "all"})
        setDate(prev => ({
            ...prev, salary: newDate
        }))
        applyFilter(newDate, "all")
    }

    const menuItem = [
        {type: "delete", text: "Удалить", handler: handleDeleteRow}]

    const paidBetween = () => {
        setModal(true)
    }
    const handleSubmit = (data, onClose) => {
        JobWorkersService.paidBetween(DateTimeUtil.convertToJavaDate(data.startShipped), DateTimeUtil.convertToJavaDate(data.finishShipped))
            .then(function () {
                onClose()
                handleModalAlert("Выплачено", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleSelectAction = () => {
        JobWorkersService.paidIds({"ids": rowSelection})
            .then(function () {
                setOpen(false)
                setRowSelection([])
                handleModalAlert("Выплачено", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const modalActions = [{type: "paid", name: "Выплатить"}]
    return (
        <Box sx={{
            overflow: 'auto',
            maxWidth: 'calc(100vw - 50px)', width: "2700px"
        }}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <Box sx={{display: 'flex', justifyContent: "spase-between", alignItems: "flex-end", gap: "9px"}}>
                    <Box sx={{width: "260px"}}>
                        <TextFieldValidation
                            select
                            name="workerId"
                            label="Работники"
                            value={formState.workerId}
                            setCurrValues={setFormState}
                            height={51}
                        >
                            <MenuItem key={"all"} value={"all"}>
                                Все
                            </MenuItem>
                            {workers?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.lastName} {option.firstName.substr(0, 1)}.{option.middleName.substr(0, 1)}.
                                </MenuItem>
                            ))}
                        </TextFieldValidation>
                    </Box>
                    <Box>
                        <Typography sx={{
                            fontSize: "16px",
                            fontWeight: 700
                        }}>{"Отгружено от"}</Typography>
                        <DateInput
                            value={date.startShipped}
                            setValue={(value) => setDate(prev => ({
                                ...prev, salary: {...prev.salary, startShipped: value},
                            }))}
                            variant={"outlined"}
                        />
                    </Box>
                    <Box>
                        <Typography sx={{fontSize: "16px", fontWeight: 700}}>Отгружено до</Typography>
                        <DateInput
                            value={date.finishShipped}
                            setValue={(value) => setDate(prev => ({
                                ...prev, salary: {...prev.salary, finishShipped: value},
                            }))}
                            helperText={"Отгружено до"}
                            variant={"outlined"}
                        />
                    </Box>
                    <Box>
                        <Typography sx={{fontSize: "16px", fontWeight: 700}}>Выполнено от</Typography>
                        <DateInput
                            variant={"outlined"}
                            value={date.startCompletion}
                            setValue={(value) => setDate(prev => ({
                                ...prev, salary: {...prev.salary, startCompletion: value},
                            }))}
                        />
                    </Box>
                    <Box>
                        <Typography sx={{fontSize: "16px", fontWeight: 700}}>Выполнено до</Typography>
                        <DateInput
                            value={date.finishCompletion}
                            setValue={(value) => setDate(prev => ({
                                ...prev, salary: {...prev.salary, finishCompletion: value},
                            }))}
                            variant={"outlined"}
                        />
                    </Box>
                    <Box>
                        <Typography sx={{fontSize: "16px", fontWeight: 700}}>Оплачено от</Typography>
                        <DateInput
                            value={date.startPaid}
                            setValue={(value) => setDate(prev => ({
                                ...prev, salary: {...prev.salary, startPaid: value},
                            }))}
                            variant={"outlined"}
                        />
                    </Box>
                    <Box>
                        <Typography sx={{fontSize: "16px", fontWeight: 700}}>Оплачено до</Typography>
                        <DateInput
                            value={date.finishPaid}
                            setValue={(value) => setDate(prev => ({
                                ...prev, salary: {...prev.salary, finishPaid: value},
                            }))}
                            variant={"outlined"}
                        />
                    </Box>
                    <ButtonCreate
                        text={"Применить фильтр"}
                        width={170}
                        height={43}
                        icon={false}
                        onClick={() => applyFilter()}
                    />
                    <ButtonCreate
                        text={"Отменить фильтр"}
                        width={160}
                        height={43}
                        icon={false}
                        onClick={() => cancelFilter(false)}
                    />
                    <ButtonCreate
                        text={"Очистить фильтр"}
                        width={160}
                        height={43}
                        icon={false}
                        onClick={() => cancelFilter(true)}
                    />
                    <ButtonCreate
                        text={"Выплатить от и до"}
                        width={160}
                        height={43}
                        icon={false}
                        onClick={() => paidBetween()}
                    />
                </Box>
            </Box>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='ru'
                localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    muiTableContainerProps={{
                        sx: {
                            width: "2700px",
                            maxHeight: rowSelection?.length > 0 ? `calc(100vh - 680px)` : `calc(100vh - 585px)`
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:first-of-type": {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                    }}
                    columns={columns}
                    data={data || []}
                    rowHeight={13}
                    columnSpacing={1}
                    getRowId={(originalRow) => originalRow.id}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    manualPagination={true}
                    state={{
                        rowSelection: currentSelection,
                        showGlobalFilter: true,
                        pagination: {
                            pageIndex: tableOptions.pageIndex,
                            pageSize: tableOptions.pageSize
                        }
                    }}
                    onRowSelectionChange={onRowSelectionChange}
                    rowCount={tableOptions.totalElements}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                    }}
                    muiPaginationProps={{
                        rowsPerPageOptions: [
                            5, 10, 20, 30, 50, 100, 500, 1000
                        ],
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            disabled={row.original.paid}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    localization={MRT_Localization_RU}
                    enableToolbarInternalActions={false}
                    enableRowActions={true}
                    enableRowSelection={true}
                    enablePagination={true}
                />
                <ModalPaidBetween modalOpen={modal} handleClose={() => setModal(false)} handleSubmit={handleSubmit}/>
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                {open && <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />}
            </LocalizationProvider>
        </Box>
    );
};
const ModalPaidBetween = ({
                              modalOpen,
                              handleClose,
                              handleSubmit,
                          }) => {
        const [date, setDate] = useState({
            startShipped: null,
            finishShipped: null,
        });
        const onClose = () => {
            handleClose()
            setDate({
                startShipped: null,
                finishShipped: null
            })
        }
        return (
            <div>
                <Dialog open={modalOpen} onClose={handleClose}>
                    <DialogTitle textAlign="center">Выплатить от и до</DialogTitle>
                    <DialogContent sx={{display: "flex", gap: "20px"}}>
                        <Box>
                            <Typography sx={{fontSize: "16px", fontWeight: 700}}>Выплатить от</Typography>
                            <DateInput
                                value={date.startShipped}
                                setValue={(value) => setDate(prev => ({...prev, startShipped: value}))}
                                variant={"outlined"}
                            />
                        </Box>
                        <Box>
                            <Typography sx={{fontSize: "16px", fontWeight: 700}}>Выплатить до</Typography>
                            <DateInput
                                value={date.finishShipped}
                                setValue={(value) => setDate(prev => ({...prev, finishShipped: value}))}
                                variant={"outlined"}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{display: "flex", alignItems: "flex-end", p: '1.25rem'}}>
                        <ButtonExit text={"Выйти"} onClick={onClose}/>
                        <ButtonAdd text={"Выплатить"} disabled={!date.startShipped || !date.finishShipped}
                                   onClick={() => handleSubmit(date, onClose)}/>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
;


export default SalaryTable;